import { useLayoutEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet, ScrollRestoration, useLocation } from 'react-router-dom';
import { pageTitleKey } from '@/lib/pageTitles';
import { ROUTES } from '@/routes/paths';

// Общее для всех страниц: заголовок вкладки по разделу и прокрутка: новый переход открывает страницу сверху, «назад»
// возвращает на прежнее место. Смена параметров адреса без ухода со страницы (вкладки, фильтры) передаёт
// `preventScrollReset`, иначе страница подпрыгивала бы наверх.
export default function RouteShell() {
  const { t } = useTranslation();
  const { pathname } = useLocation();

  // useLayoutEffect: срабатывает раньше эффектов страницы, и NotFound может задать свой заголовок поверх.
  useLayoutEffect(() => {
    const key = pageTitleKey(pathname);
    if (pathname === ROUTES.HOME) {
      document.title = t('landing.pageTitle');
    } else {
      document.title = key ? `${t(key)} — ${t('app.name')}` : t('app.name');
    }
  }, [pathname, t]);

  return (
    <>
      <ScrollRestoration />
      <Outlet />
    </>
  );
}
